import { useState } from "react";
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./MyGallery.css"
import { galleryImages } from './image-gallery-data';

export default function MyGallery(props){

    const slides = galleryImages.map(({ src, width, height }) => ({
      src,
      width,
      height,
    }));


    const [index, setIndex] = useState(-1);
    const handleClick = (index, item) => {
      setIndex(index);
    };


    return (
        <>
          <div>
            <Gallery
              images={galleryImages}
              onClick={handleClick}
              enableImageSelection={false}
              render={{
                buttonPrev: null,
                buttonNext: null,
                buttonClose: null,
              }}
            />
            <Lightbox
              slides={slides}
              open={index >= 0}
              index={index}
              close={() => {
                setIndex(-1);
              }}
            />
          </div>
          <style>

          </style>
        </>
        
      );
}


